module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (true),
      expression: "true"
    }],
    staticClass: "modal-mask",
    class: {
      "bring-back": _vm.bringBack
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-lg"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.closable) ? _c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._t("header")], 2), (_vm.tabbedModal) ? _c('div', {
    staticClass: "modal-tabbed"
  }, [_vm._t("body")], 2) : _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body")], 2), (_vm.showFooter) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer"), (_vm.defaultCloseButton) ? _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "disabled": false,
      "label": _vm.$t("dataTable.labels.acaoFechar"),
      "customClass": "secondary",
      "id": _vm.id + "ButtonClose",
      "clickFunction": _vm.close
    }
  }) : _vm._e()], 2) : _vm._e()])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ea2dd414", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea2dd414"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/betterModal/betterModal.pug
// module id = 1466
// module chunks = 0